import axios from '../../utils/axiosConfig';
// import axios from 'axios';
import {
  UPLOAD_DOCUMENT_REQUEST,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_FAIL,
  GET_DOCUMENTS_REQUEST,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_FAIL,
  DOWNLOAD_DOCUMENT_REQUEST,
  DOWNLOAD_DOCUMENT_SUCCESS,
  DOWNLOAD_DOCUMENT_FAIL,
  UPDATE_DOCUMENT_REQUEST,
  UPDATE_DOCUMENT_SUCCESS,
  UPDATE_DOCUMENT_FAIL,
} from '../constants/documentConstants';

export const uploadDocument = (formData) => async (dispatch) => {
  try {
    dispatch({ type: UPLOAD_DOCUMENT_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    console.log(formData);
    const { data } = await axios.post('/api/documents/upload', formData, config);

    dispatch({ type: UPLOAD_DOCUMENT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: UPLOAD_DOCUMENT_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const getDocumentsByCaseFile = (caseFileId) => async (dispatch) => {
  try {
    dispatch({ type: GET_DOCUMENTS_REQUEST });

    const { data } = await axios.get(`/api/documents/case-file/${caseFileId}`);
    // console.log(data);
    dispatch({ type: GET_DOCUMENTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_DOCUMENTS_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const getAllDocuments = () => async (dispatch) => {
  try {
    dispatch({ type: GET_DOCUMENTS_REQUEST });

    const { data } = await axios.get('/api/documents/all');

    dispatch({ type: GET_DOCUMENTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: GET_DOCUMENTS_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const downloadDocument = (documentId) => async (dispatch) => {
  try {
    dispatch({ type: DOWNLOAD_DOCUMENT_REQUEST });

    const { data } = await axios.get(`/api/documents/download/${documentId}`);
    // console.log(data);
    dispatch({ type: DOWNLOAD_DOCUMENT_SUCCESS, payload: data });

    return data; // Return the data directly
  } catch (error) {
    dispatch({
      type: DOWNLOAD_DOCUMENT_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const updateDocument = (documentId, formData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_DOCUMENT_REQUEST });

    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    const { data } = await axios.put(`/api/documents/update/${documentId}`, formData, config);

    dispatch({ type: UPDATE_DOCUMENT_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: UPDATE_DOCUMENT_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};